import isSpacedString from "@/helpers/isSpacedString";
import { defineStore } from "pinia";
import { ref } from "vue";

import useAuthUser from "@/composables/useAuthUser";
import type { CompanyGroup } from "@/interfaces/companyGroup";
import { Pagination } from "@/interfaces/paginatedResponse";

export const useCompanyGroupsStore = defineStore("companyGroups", () => {
  const { user } = useAuthUser();

  const query = ref("");
  const company = ref<number>(user.value?.companyId || 0);
  const companyGroups = ref<CompanyGroup[]>([]);
  const page = ref<string>("1");
  const pagination = ref<Pagination>();

  return {
    query,
    companyGroups,
    company,
    page,
    pagination,

    setQuery(value: string) {
      if (!isSpacedString(value)) {
        query.value = value;
      }
    },

    setCompany(value: string) {
      company.value = Number(value);
    },

    setCompanyGroups(value: CompanyGroup[] | undefined) {
      companyGroups.value = value || [];
    },

    setPage(value: string) {
      page.value = value;
    },

    setPagination(value: Pagination) {
      pagination.value = value;
    },

    resetState() {
      query.value = "";
      companyGroups.value = [];
    },
  };
});
